<div class="content-wrapper">
    <ng-template #content>
        <div id="modal">
            <div class="modal-header font-weight-bold">
                <h4 class="modal-title font-weight-bold">Share Admission Link</h4>
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="modalService.dismissAll('')"
                >
                    ×
                </button>
            </div>
            <div class="modal-body">
                <div class="container">
                    <div class="row mt-40px mb-5">
                        <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-xs-12">
                            <input class="form-control font-small-4" type="text" [value]="this.admissionLink"/>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12">
                            <i class="fas fa-copy text-center f_20 mt-1 ml-2 cursor-pointer" title="Copy"
                               (click)="copyMessage()"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer justify-content-center">
            <span class="mt-1 mb-1">
                <i class="fab fa-facebook-square fa-2x color-facebook cursor-pointer"
                   (click)="navigateTo('https://www.facebook.com/sharer/sharer.php?u='+admissionLink)"></i>
                <i class="fab fa-twitter-square fa-2x color-twitter mr-1 ml-1 cursor-pointer"
                   (click)="navigateTo('http://twitter.com/share?url='+this.admissionLink)"></i>
                <i class="fab fa-instagram fa-2x color-instagram cursor-pointer"
                   (click)="navigateTo('https://www.instagram.com/?url='+admissionLink)"></i>
            </span>
        </div>
    </ng-template>
    <div class="content-body" *ngIf="user['user_type'] !== 'STUDENT'">
        <div class="row mb-1">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"></div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <form class="row" novalidate [formGroup]="studentSessionForm">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <select class="form-control" formControlName="university_id"
                                (change)="changeStudentUniversity($event)" *ngIf="['SUPER_ADMIN'].indexOf(user['user_type']) !== -1">
                            <option class="text-center" [value]="university.id"
                                    *ngFor=" let university of universities">{{university?.name}}</option>
                        </select>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <select class="form-control" formControlName="student_session_year"
                                (change)="changeStudentSession($event)">
                            <option class="text-center" [value]="studentSessionYear.id"
                                    *ngFor=" let studentSessionYear of studentSessionYears">{{studentSessionYear?.session_name}}
                                - {{studentSessionYear?.session_year}}</option>
                        </select>
                    </div>
                </form>
            </div>
        </div>
        <div class="row match-height">
            <div class="col-lg-4 col-md-12 col-sm-12">
                <div class="card card-congratulations">
                    <div class="card-body text-center">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAAB0CAMAAABExqW4AAAB/lBMVEUAAABiVu5iVu5Hi9L/vAFiVu5iVu7/vAFiVu5iVu5iVu5iVu5iVu5iVu5iVu5iVu78syv/vAFiVu5iVu5iVu7/vAFiVu5iVu7/vAFiVu5iVu7/vAFiVu7tj51iVu5iVu5iVu7/vAH/vAFiVu5iVu5iVu5iVu5iVu7/vAFiVu5iVu5iVu5iVu5iVu5iVu78tCn/vAFiVu7/vAFiVu5iVu5iVu5iVu7/vAH/vAHtj53/vAHtj51iVu5iVu7/vAFiVu4b0af/vAH/vAFiVu5iVu5iVu4b0aftj53/vAH/vAHtj51iVu7/vAEb0acb0adiVu7/vAH/vAHtj53/vAFiVu5iVu7/vAFiVu5iVu5iVu7/vAH/vAFiVu5iVu7tj53tj51iVu4b0adiVu5iVu7/vAH/vAH/vAFiVu7/vAH/vAH/vAEb0acb0af/vAH/vAH/vAH/vAH/vAH/vAFiVu7/vAH/vAH/vAFiVu4b0acb0af/vAFiVu7/vAEb0acb0acb0af/vAEb0af/vAH/vAH/vAH/vAEb0aftj53tj53/vAEb0af/vAH/vAEb0aftj53/vAEb0aftj53tj50b0aftj53tj50b0acb0af/vAEb0acb0acb0acb0aftj53tj53tj50b0aftj53tj53tj53tj53tj51iVu7/vAHtj50b0ae3TuNqAAAApnRSTlMABvYD4f0L8RTpiPLhtTglBP76zEz37L6YGwL0pZmRg0L85uWuoXcvIx4Pl41vXgfruaacZlM8Hw/17+Pb1NLIsa+OamFWS0g+OCMhE/3s19bPwb6yqaF+c1lZSUYYFvzdyMN7e2tONCgXDfvjy7i0m4N0Tzs0LSsiFtzQxcKhlIqHcWVDMZp7b25gXlMzHQoH79fWzru3p5N8d3A/27OhVVE9L6mPdPsNfAAAChJJREFUeNrE2utTElEYBvDHQCgzg5LEyEysJLtgVELYja5iZjo0VlBTlpqa10q7WVnqhybLmma6TH0+R/7LVjda2N1z9pC76++rMw7PvMt73vMusMFghOpww1KNZbCLpy9O7U/oOr2uBPaYH6HU/oSuKkJ2wQ5DZ+voGiQs2UQIqYUN+p2UyQnLOHYTyWlYLjpG6VokdOwgy0obYS3PowBdk4TbjxDZY1gqlvBSkxK21bTcaalpg6Cd5K/9sNDkeICOvj9lSsJLx5eWHb8EIWUk5yqsEuvropIJYPJH06oTtkkB5YhCVbxOFNWwRFIq34oFSMILKe/qEtYs5dTA2A2S5xBk5pdPFoIs2vtiNQlblnJaYOgcybcHZkt257XPOBSt3b7/TnhnKecOjBwiBerNLl9hY0kV/nV22voaXiglhZ7CPE80VToLlYGZgrZzyvTvYeUWonIOJmnXOxc+QMPTn6grOmHbF8FeeksTkFwD1883Z3qGvwuWT2sKegbfdSoJTT0Pm9cRjY0O8HRkJa+Myid/Yi2fBwxJv7uohPhU03K8peYTuCo2Eh0V4PmalXwFT2vERxlGwLaYTnmlhGZq2Eb03AdPT1bSwS8f2zi4QhNjMNHTDURXFXjODH/99vot9ExOjMnlY5uFjTaXE33rXCiep/Wsk9IuaiAJ+1SXE5ZbKFI445cPtXS/k/LULaKA48xFWOX2CcJUhmIsLkTiVOZtl1cwTJ0o9Db78Bessf4kYdsKYbEPiYBqIJkcoUwRFLh4Reparz/DCrUvNxCm0vUQMjg76tMZyTzvA5ThEfI968gu63kOa5Rsbr55Y+fu0/WlRO0CjEXfpTTPY7/RsmkO+V5lZcMfYbYbDcjjqK44drBsx72764RXGQO9I16dPjKEnIUg1dOOfB+Hs7JXMNf2MtY1d31D5dHaPYdPvgTP/ATjTJ+GIvbDa3y9fd6TXdbxDKZyHOF2Sz7PE+nYY5lAvqT2cExA5fNrKeCVizBVyW7O/YHPM+cPUo5Wo9XoBDR+Pcy+hakaq4jkLoqX6Y5TLl8YKqFRdSfSunjGATPd3iqfBy4IG5rqf3820ZVKvqB8o9BKFxQ9Cstdzk0yD2AoPJDpm4mMNP07yobGKVcvdMT8SsdpguUa6kV3hpHpoOokGATQ30Q5JqHrSaeyhbJa8zbh0ZOqjclTzChlinugL9zrU0YeS1XmrSw2FZswDVmfjzIkwBRKKf/DQoe2EEV5kQndYfw1wLoD9oHjw/LzPQBLHSQFXODibB/CM16qZwo87d3egAcW2l5b1LoJ3MO81Um1gjAw1w0rKJOayvmiEr5AgViEcfWznzKpqR0Al9FRl45zltn2c1URjU3FJPSGoBZN0UJRrJ31W4lWObjY1yJlrvZpnmP7KZOaViN4RLac851U4ceaeVpPdFWIJ/TFoGsx75abxlqp2EYU4s1UsE1mgsoe0W7KpMawUzxhBkztCbqiC6aK+p0+pz8KYze3EJbDwgmDHnDMBswfqufc8qg4ByN7CVu9cMIZcIWm5TKbJ+SmMncIfJUbyIFNzM1vo2jCKfB5euvqhsCytALF8At26MYjcox9j2t1YzYLJuwS+T0JzEzoFPtlxq1yItkHWbU25lFwBJWE7yDA1IR1yjkFJtd+suIy8lRXXr9WL9ZMB5ry1hcCbK9h810ia4Da7VzMKvBM5SKOQYi938OSA6WEsVNTYu7eCq75vxHT9icMBagsEIKuByc57UTcfJxK4mH1W9vflidERo7ozugXsHYL94W1uEm3/Jxo3tpanhCh8aA36NevYMNLkq8Sq5D8082d9SYRRXEA/8+QQeiwKDQgiJRoaUMLGFKo0dhUU7VqTTRE0pLY1rQmdYk+qHGNy1Pb9MGosRob9+WI31KYUrY7dzoVZgB/r0xCDsy95957zkwxxHsqVdvlV2gby6KHqXU24d6ux1Cr2j59hDZxj1ODPJpy5g74VVvzBRMiNUqjFdiq7Tu0gXuBWBNoErdqa7rghEgqBtAkXtXWdLEUqVpEy20oVVuzJWVue1PrnX5ngclmLxFPHP+DvI+4htH9bDnSMIKud9dOWkLoeq6QSBr60e3cOXKMhu3E40RV9u2XlW/noMuJs+gIgREPkRewREZ82/dsH2GeoeHb9fvENbSdrUesHu0KvVGZWAuoeFkoyUKXPcUDmr3X0VbWRV/DZCJkcsyYHEPFJPOUkGaERfuuon2EiYNqZ2bWfL/Ii3C1ULKq9y4tOnoGoeHMENogmL9CFdOoM5R0eqjC0fi013f9ER64D6SJpPG+iABz9T7R3iDZ0n6JrU5kCyVzuiO8eBiAVaYSMTUzGIRZXAs6DipmE5tXyah4XSh6Db0R3jqPkmHaYs+lp2CCB8wqOwJ1sRkvkYiKc99Wvrxdhz4Hbt+AYpBqXRnO2GCoqahEjQbB5V4cw795cQhl41RP8vYYNyxtYQ+xAjDUSWKJqYGlIFpuqE8mNQIMZfWRKl8u7UYrCQnON4kwWJi4roycsqE1LCcd3G+BwR6QFikcOraQC88kI24rmjDgIR4vjLZAGvqFmEhl4gV/KJ44NaozVuuUq/fkQDzq9DqcQCwscnsqjJYkvmELsEgM31gq2pPIuGICPyqxsX3J1udr0y5e8BFPn/L5MeKzjzmjfckIE5XqPt06c5BYYRguTuqkNBSXaRun7kqkQXqALUKa/bmmYTg3qRIzKOsnTXFggjREUSOY8TKVCYNY3p9GmZ9U+EaxJSaSBr8FQA9xeaZQL+JnFt6GeP7n5ho25Yl1cFBn85XDhqJgaCdnukv9ElVEYIyNUgXmAxSCnRpdiKGGcIF4PC4oBD+pE2ehwj3iYRbeLf8LS55Dwdxj4zZUaE82aZQNPdlZaSUQlw1eeH8olew3oHBLVMfJ5PTc9ofuNtWsItvAY5v2GbvwXrup/IWKFNWKWtAoJpMar4Aqt32n9T9rwkEyjHP6fSWSDNXoCert9LTHUMslsldYoUlIXoIpLNXFhpQAgzPZSJdRj838CXSKPirz8NJTREeNncn8DgGdIiaRQo6AJ8csN4Ng9DT203cOJ5XYl8AVkBtS5hBYweG6SyzoHL1UdGxKf1u57IYayyWqyqCDWBxE3lkwuJNNhvu24mouCaKTTJPfCm0RzaUKm/kvo6MEogK2E6ItKWaEsZnfj+4TkKsbCgaT+V3oQjOkEJd0vMvQiW4kjOlLc3kiaRCqJrNz6GQRtT3tw+XjbGYJQdXqfOFtZ4cYIhoXUOvj8eI+bA0Nwm6o2K3Ucd+YGOKP9ckdTzb2AGp8LXekPoIOc9mC4jNMcu5nofDpEHYmMYpaz/5sWoYO6wWFaSPx13yhaAVNeVR+ZdlX6PDyjdIvshsmWSkUze9Hc9aKJ1q6H0OZe1OYX4VpDn0qjogfaNbx5YfQbS47CRNNZr/jP/UXWwY/uvmwUHIAAAAASUVORK5CYII="
                             class="congratulations-img-left"
                             alt="card-img-left"/>
                        <img src="data:image/png;base64,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"
                             class="congratulations-img-right"
                             alt="card-img-right"/>
                        <div class="avatar avatar-xl bg-primary shadow">
                            <div class="avatar-content">
                                <i data-feather="award" class="font-large-1"></i>
                            </div>
                        </div>
                        <div class="text-center">
                            <h1 class="mb-1 text-white text-capitalize">Welcome {{user?.name.toLowerCase()}}</h1>
                            <p class="card-text m-auto w-75">Logged In as <strong>
                                <span class="text-capitalize"
                                      *ngIf="user['user_type'] !== 'SUPER_ADMIN' && user['user_type'] !== 'HEAD_COUNSELLOR' && user['user_type'] !== 'BUSINESS_ADMIN' && user['user_type'] !== 'BUSINESS_HEAD_CENTER' && user['user_type'] !== 'BUSINESS_CENTER'">{{user['user_type'].toLowerCase()}}</span>
                                <span class="text-capitalize"
                                      *ngIf="user['user_type'] === 'SUPER_ADMIN'">Superadmin</span>
                                <span class="text-capitalize"
                                      *ngIf="user['user_type'] === 'HEAD_COUNSELLOR'">Head Counsellor</span>
                                <span class="text-capitalize"
                                      *ngIf="user['user_type'] === 'BUSINESS_ADMIN'">Business Admin</span>
                                <span class="text-capitalize"
                                      *ngIf="user['user_type'] === 'BUSINESS_HEAD_CENTER'">Business Head Center</span>
                                <span class="text-capitalize"
                                      *ngIf="user['user_type'] === 'BUSINESS_CENTER'">Business Center</span>
                            </strong>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-8 col-md-6 col-12">
                <div class="card card-statistics">
                    <div class="card-header">
                        <h4 class="card-title">Students</h4>
                    </div>
                    <div class="card-body statistics-body">
                        <div class="row">
                            <!--<div class="col-sm-6 col-xl-3 mb-2 mb-xl-0">
                                <div class="media">
                                    <div class="avatar bg-light-info mr-2">
                                        <div class="avatar-content">
                                            <i data-feather="user" class="avatar-icon"></i>
                                        </div>
                                    </div>
                                    <div class="media-body my-auto">
                                        <h4 class="font-weight-bolder mb-0">{{registeredStudents}}</h4>
                                        <p class="card-text font-small-3 mb-0">Registered Students</p>
                                    </div>
                                </div>
                            </div>-->
                            <div class="col-sm-6 col-xl-3 mb-2 mb-xl-0">
                                <div class="media">
                                    <div class="avatar bg-light-success mr-2">
                                        <div class="avatar-content">
                                            <i data-feather="trending-up" class="avatar-icon"></i>
                                        </div>
                                    </div>
                                    <div class="media-body my-auto">
                                        <h4 class="font-weight-bolder mb-0">{{admissionDone}}</h4>
                                        <p class="card-text font-small-3 mb-0">Admission Done</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-xl-3 mb-2 mb-xl-0">
                                <div class="media">
                                    <div class="avatar bg-light-success mr-2">
                                        <div class="avatar-content">
                                            <i data-feather="trending-up" class="avatar-icon"></i>
                                        </div>
                                    </div>
                                    <div class="media-body my-auto">
                                        <h4 class="font-weight-bolder mb-0">{{reRegistrationDone}}</h4>
                                        <p class="card-text font-small-3 mb-0">Re - Registration</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-xl-3 mb-2 mb-xl-0">
                                <div class="media">
                                    <div class="avatar bg-light-success mr-2">
                                        <div class="avatar-content">
                                            <i data-feather="trending-up" class="avatar-icon"></i>
                                        </div>
                                    </div>
                                    <div class="media-body my-auto">
                                        <h4 class="font-weight-bolder mb-0">{{lateralEntryDone}}</h4>
                                        <p class="card-text font-small-3 mb-0">Lateral Entry</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-xl-3 mb-2 mb-xl-0">
                                <div class="media">
                                    <div class="avatar bg-light-success mr-2">
                                        <div class="avatar-content">
                                            <i data-feather="trending-up" class="avatar-icon"></i>
                                        </div>
                                    </div>
                                    <div class="media-body my-auto">
                                        <h4 class="font-weight-bolder mb-0">{{creditTransferDone}}</h4>
                                        <p class="card-text font-small-3 mb-0">Credit Transfer</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-xl-3" *ngIf="admissionLink">
                                <div class="media">
                                    <div class="avatar bg-light-success mr-2"
                                         *ngIf="user && user['user_type'] === 'COUNSELLOR'">
                                        <div class="avatar-content">
                                            <i class="fas fa-share-square avatar-icon f_23"></i>
                                        </div>
                                    </div>
                                    <div class="avatar bg-light-danger mr-2"
                                         *ngIf="user && user['user_type'] && (user['user_type'] === 'SUPER_ADMIN' || user['user_type'] === 'ADMIN' || user['user_type'] === 'HEAD_COUNSELLOR')">
                                        <div class="avatar-content">
                                            <i class="fas fa-exclamation-triangle avatar-icon f_23"></i>
                                        </div>
                                    </div>
                                    <div class="media-body my-auto">
                                        <h4 class="font-weight-bolder mb-0"
                                            *ngIf="user && user['user_type'] && (user['user_type'] === 'ADMIN' || user['user_type'] === 'SUPER_ADMIN' || user['user_type'] === 'HEAD_COUNSELLOR')">
                                            {{notConnectedStudents}}
                                        </h4>
                                        <p class="card-text font-small-3 mb-0"
                                           *ngIf="user && user['user_type'] && (user['user_type'] === 'ADMIN' || user['user_type'] === 'SUPER_ADMIN' || user['user_type'] === 'HEAD_COUNSELLOR')">
                                            Not Connected</p>
                                        <span class=" badge badge-primary font-small-3 mb-0 cursor-pointer"
                                              *ngIf="user && user['user_type'] && user['user_type'] === 'COUNSELLOR'"
                                              (click)="openShareLink(content)">Admission Link</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="row match-height">
            <div class="col-lg-4 col-md-6 col-12">
                <div class="card card-developer-meetup">
                    <div class="bg-light-primary rounded-top text-center">
                        <img src="assets/images/illustration/marketing.svg" alt="Meeting Pic" height="170"/>
                    </div>
                    <div class="card-body">
                        <div class="meetup-header d-flex align-items-center">
                            <div class="my-auto">
                                <h4 class="card-title mb-25"
                                    *ngIf="user && ['SUPER_ADMIN'].indexOf(user['user_type']) !== -1">
                                    Business Admins</h4>
                                <h4 class="card-title mb-25"
                                    *ngIf="user && ['BUSINESS_ADMIN', 'BUSINESS_HEAD_CENTER', 'BUSINESS_CENTER'].indexOf(user['user_type']) !== -1">
                                    Business Admin</h4>
                                <h4 class="card-title mb-25"
                                    *ngIf="user && ['UNIVERSITY'].indexOf(user['user_type']) !== -1">
                                    Courses</h4>
                            </div>
                        </div>
                        <div class="avatar-group"
                             *ngIf="admins && admins.length > 0 && user && ['SUPER_ADMIN', 'BUSINESS_ADMIN', 'BUSINESS_HEAD_CENTER', 'BUSINESS_CENTER'].indexOf(user['user_type']) !== -1">
                            <div placement="bottom" [title]="admin.name" class="avatar pull-up"
                                 *ngFor="let admin of admins">
                                <img [src]="admin['admin_detail']['profile_image'].url"
                                     [alt]="admin?.name" width="33"
                                     height="33"
                                     *ngIf="admin && admin['admin_detail'] && admin['admin_detail'] && admin['admin_detail'].profile_image"/>
                                <img src="./assets/images/image-backgrounds/1600-1600.jpg"
                                     [alt]="admin?.name" width="33"
                                     height="33"
                                     *ngIf="!admin || !admin['admin_detail'] || !admin['admin_detail'].profile_image"/>
                            </div>
                        </div>
                        <div class="avatar-group"
                             *ngIf="admins && admins.length > 0 && user && ['BUSINESS_HEAD_CENTER'].indexOf(user['user_type']) !== -1">
                            <div placement="bottom" [title]="admin['admin'].name" class="avatar pull-up"
                                 *ngFor="let admin of admins">
                                <img [src]="admin['admin']['admin_detail']['profile_image'].url"
                                     [alt]="admin['admin'].name" width="33"
                                     height="33"
                                     *ngIf="admin && admin['admin'] && admin['admin']['admin_detail'] && admin['admin']['admin_detail'].profile_image"/>
                                <img src="./assets/images/image-backgrounds/1600-1600.jpg"
                                     [alt]="admin['admin'].name" width="33"
                                     height="33"
                                     *ngIf="!admin || !admin['admin'] || !admin['admin']['admin_detail'] || !admin['admin']['admin_detail'].profile_image"/>
                            </div>
                            &lt;!&ndash;<h6 class="align-self-center cursor-pointer ml-50 mb-0">+22</h6>&ndash;&gt;
                        </div>
                        <h4 *ngIf="user && ['UNIVERSITY'].indexOf(user['user_type']) !== -1">{{courseCount}}</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
                <div class="card card-developer-meetup">
                    <div class="bg-light-primary rounded-top text-center">
                        <img src="assets/images/illustration/email.svg" alt="Meeting Pic" height="170"/>
                    </div>
                    <div class="card-body">
                        <div class="meetup-header d-flex align-items-center">
                            <div class="my-auto">
                                <h4 class="card-title mb-25"
                                    *ngIf="user && user['user_type'] !== 'UNIVERSITY' && user['user_type'] !== 'BUSINESS_HEAD_CENTER'">
                                    Business Head Center</h4>
                                <h4 class="card-title mb-25"
                                    *ngIf="user && user['user_type'] !== 'UNIVERSITY' && user['user_type'] === 'BUSINESS_HEAD_CENTER'">
                                    Business Center</h4>
                                <h4 class="card-title mb-25" *ngIf="user && user['user_type'] === 'UNIVERSITY'">
                                    Programs</h4>
                            </div>
                        </div>
                        <div class="avatar-group"
                             *ngIf="headCounsellors && headCounsellors.length > 0 && user && user['user_type'] !== 'UNIVERSITY' && user['user_type'] !== 'BUSINESS_HEAD_CENTER'">
                            <div placement="bottom" [title]="headCounsellor['user'].name" class="avatar pull-up"
                                 *ngFor="let headCounsellor of headCounsellors">
                                <img [src]="headCounsellor['head_counsellor_detail']['profile_image'].url"
                                     [alt]="headCounsellor['user'].name" width="33"
                                     height="33"
                                     *ngIf="headCounsellor && headCounsellor['head_counsellor_detail'] && headCounsellor['head_counsellor_detail'].profile_image"/>
                                <img src="./assets/images/image-backgrounds/1600-1600.jpg"
                                     [alt]="headCounsellor['user'].name" width="33"
                                     height="33"
                                     *ngIf="!headCounsellor || !headCounsellor['head_counsellor_detail'] || !headCounsellor['head_counsellor_detail'].profile_image"/>
                            </div>
                            &lt;!&ndash;<h6 class="align-self-center cursor-pointer ml-50 mb-0">+42</h6>&ndash;&gt;
                        </div>
                        <div class="avatar-group"
                             *ngIf="counsellors && counsellors.length > 0 && user && user['user_type'] !== 'UNIVERSITY' && user['user_type'] === 'BUSINESS_HEAD_CENTER'">
                            <div placement="bottom"
                                 [title]="(counsellor && counsellor.name) ? counsellor.name : counsellor.counsellor.name"
                                 class="avatar pull-up"
                                 *ngFor="let counsellor of counsellors">
                                <img [src]="counsellor['counsellor_detail']['profile_image'].url"
                                     [alt]="counsellor?.name" width="33"
                                     height="33"
                                     *ngIf="counsellor && counsellor['counsellor_detail'] && counsellor['counsellor_detail'].profile_image"/>
                                <img src="./assets/images/image-backgrounds/1600-1600.jpg"
                                     [alt]="counsellor?.name" width="33"
                                     height="33"
                                     *ngIf="!counsellor || !counsellor['counsellor_detail'] || !counsellor['counsellor_detail'].profile_image"/>
                            </div>
                            &lt;!&ndash;<h6 class="align-self-center cursor-pointer ml-50 mb-0">+42</h6>&ndash;&gt;
                        </div>
                        <h4 *ngIf="user && user['user_type'] === 'UNIVERSITY'">{{programCount}}</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
                <div class="card card-developer-meetup">
                    <div class="bg-light-primary rounded-top text-center">
                        <img src="assets/images/illustration/api.svg" alt="Meeting Pic" height="170"/>
                    </div>
                    <div class="card-body">
                        <div class="meetup-header d-flex align-items-center">
                            <div class="my-auto">
                                <h4 class="card-title mb-25" *ngIf="user && user['user_type'] !== 'UNIVERSITY'">
                                    Universities</h4>
                                <h4 class="card-title mb-25" *ngIf="user && user['user_type'] === 'UNIVERSITY'">
                                    Branches</h4>
                            </div>
                        </div>
                        <div class="avatar-group"
                             *ngIf="universities && universities.length > 0 && user && user['user_type'] !== 'UNIVERSITY'">
                            <div placement="bottom"
                                 [title]="(university && university.name) ? university.name : university['university'].name"
                                 class="avatar pull-up"
                                 *ngFor="let university of universities">
                                <img [src]="university['university_detail']['profile_image'].url"
                                     [alt]="university?.name" width="33"
                                     height="33"
                                     *ngIf="university && university['university_detail'] && university['university_detail'].profile_image"/>
                                <img src="./assets/images/image-backgrounds/1600-1600.jpg"
                                     [alt]="university?.name" width="33"
                                     height="33"
                                     *ngIf="!university || !university['university_detail'] || !university['university_detail'].profile_image"/>
                            </div>
                            &lt;!&ndash;<h6 class="align-self-center cursor-pointer ml-50 mb-0">+22</h6>&ndash;&gt;
                        </div>
                        <h4 *ngIf="user && user['user_type'] === 'UNIVERSITY'">{{branchCount}}</h4>
                    </div>
                </div>
            </div>
        </div>-->
    </div>
    <!--<div class="row match-height" *ngIf="user && ['HEAD_COUNSELLOR'].indexOf(user.user_type) !== -1">
        <div class="col-12">
            <div class="row p-0 mb-0">
                <div class="col-12">
                    <h4 class="mb-0 p-1 font-weight-bold font-medium-5"
                        *ngIf="user && ['HEAD_COUNSELLOR'].indexOf(user.user_type) !== -1">Your Progress</h4>
                </div>
            </div>
        </div>
    </div>-->
    <!--<div class="row" *ngIf="user && ['HEAD_COUNSELLOR'].indexOf(user.user_type) !== -1">
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{headCounsellorsSelfReport?.assigned_students}}</h2>
                        <p class="card-text">Assigned students</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-users font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{headCounsellorsSelfReport?.registration_done_students}}</h2>
                        <p class="card-text">Registration Done</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-id-card font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{headCounsellorsSelfReport?.admission_done_students}}</h2>
                        <p class="card-text">Admission Done</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-user-check font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{headCounsellorsSelfReport?.not_connected_students}}</h2>
                        <p class="card-text">Not Connected</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-phone-slash font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->

    <!--<div class="row match-height" *ngIf="user && ['SUPER_ADMIN'].indexOf(user.user_type) !== -1">
        <div class="col-12">
            <div class="row p-0">
                <div class="col-9">
                    <h4 class="mb-0 p-1 mb-1 font-weight-bold font-medium-5">Business Admin's Progress</h4>
                </div>
                <div class="col-3">
                    <div class="form-group m-1">
                        <select class="form-control" (change)="getAdminReport($event.target.value)">
                            <option>Select Admins</option>
                            <option [value]="admin?.id"
                                    *ngFor="let admin of admins">{{admin?.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="user && ['SUPER_ADMIN'].indexOf(user.user_type) !== -1">
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{adminsProgressReport?.assigned_students}}</h2>
                        <p class="card-text">Head Center's</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-user-check font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{adminsProgressReport?.registration_done_students}}</h2>
                        <p class="card-text">students</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-users font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{adminsProgressReport?.admission_done_students}}</h2>
                        <p class="card-text">Admission comm</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-id-card font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{adminsProgressReport?.not_connected_students}}</h2>
                        <p class="card-text">Re-Regis comm</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            &lt;!&ndash; <i class="fas fa-phone-slash font-medium-5"></i>&ndash;&gt;
                            <i class="fas fa-id-card font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row match-height" *ngIf="user && ['SUPER_ADMIN', 'ADMIN'].indexOf(user.user_type) !== -1">
        <div class="col-12">
            <div class="row p-0">
                <div class="col-9">
                    <h4 class="mb-0 p-1 mb-1 font-weight-bold font-medium-5">Business Head Center's Progress</h4>
                </div>
                &lt;!&ndash;<div class="col-3">
                    <div class="form-group m-1">
                        <select class="form-control" (change)="getHeadCounsellorReport($event.target.value)">
                            <option>Select Head Counsellors</option>
                            <option [value]="headCounsellor?.user?.id"
                                    *ngFor="let headCounsellor of headCounsellors">{{headCounsellor?.user?.name}}</option>
                        </select>
                    </div>
                </div>&ndash;&gt;
            </div>
        </div>
    </div>
    <div class="row" *ngIf="user && ['SUPER_ADMIN', 'ADMIN'].indexOf(user.user_type) !== -1">
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{headCounsellorsProgressReport?.assigned_students}}</h2>
                        <p class="card-text">Center's</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-user-check font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{headCounsellorsProgressReport?.registration_done_students}}</h2>
                        <p class="card-text">students</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-users font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{headCounsellorsProgressReport?.admission_done_students}}</h2>
                        <p class="card-text">Admission Comm</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-id-card font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0">{{headCounsellorsProgressReport?.not_connected_students}}</h2>
                        <p class="card-text">Re-Regis Comm</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-id-card font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row match-height" *ngIf="user && ['HEAD_COUNSELLOR', 'COUNSELLOR'].indexOf(user.user_type) !== -1">
        <div class="col-12">
            <div class="row p-0 mb-0">
                <div class="col-9">
                    <h4 class="mb-0 p-1 font-weight-bold font-medium-5"
                        *ngIf="user && ['HEAD_COUNSELLOR'].indexOf(user.user_type) !== -1">Counsellor's Progress</h4>
                </div>
                <div class="col-3">
                    <div class="form-group m-1" *ngIf="user && ['HEAD_COUNSELLOR'].indexOf(user.user_type) !== -1">
                        <select class="form-control" (change)="getCounsellorReport($event.target.value)">
                            <option>Select Counsellors</option>
                            <option [value]="counsellor?.counsellor?.id"
                                    *ngFor="let counsellor of counsellors">{{counsellor?.counsellor?.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="user && ['HEAD_COUNSELLOR'].indexOf(user.user_type) !== -1">
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0"
                            *ngIf="user['user_type'] === 'HEAD_COUNSELLOR'">{{counsellorsProgressReport?.assigned_students}}</h2>
                        <p class="card-text">Assigned students</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-users font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0"
                            *ngIf="user['user_type'] === 'HEAD_COUNSELLOR'">{{counsellorsProgressReport?.registration_done_students}}</h2>
                        <p class="card-text">Registration Done</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-id-card font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0"
                            *ngIf="user['user_type'] === 'HEAD_COUNSELLOR'">{{counsellorsProgressReport?.admission_done_students}}</h2>
                        <p class="card-text">Admission Done</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-user-check font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h2 class="font-weight-bolder mb-0"
                            *ngIf="user['user_type'] === 'HEAD_COUNSELLOR'">{{counsellorsProgressReport?.not_connected_students}}</h2>
                        <p class="card-text">Not Connected</p>
                    </div>
                    <div class="avatar bg-light-primary p-50 m-0">
                        <div class="avatar-content">
                            <i class="fas fa-phone-slash font-medium-5"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->
</div>
